import React from 'react';

function FilterChips({ chips, activeChip, onChipClick }) {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar py-1">
      {chips.map((chip) => {
        const isActive = activeChip === chip.id;
        return (
          <button
            key={chip.id}
            onClick={() => onChipClick(chip.id)}
            className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all ${
              isActive
                ? 'bg-primary text-on-primary shadow-sm ring-1 ring-primary/20'
                : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high'
            }`}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
}

export default FilterChips;
